import { render, staticRenderFns } from "./ExpenseNew.vue?vue&type=template&id=4b9557c3&"
import script from "./ExpenseNew.vue?vue&type=script&lang=js&"
export * from "./ExpenseNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports